import Animation from '../../animations/animation'
import StyleTweeners from '../style-tweeners'

class SplitAreaAnimation extends Animation {

  constructor (options) {
    super(options)
    this.styleTweeners = new StyleTweeners(this.styles)
  }

  match (serie) {
    // TODO This is copied from split-line animation
    if (!this.previous.scalers.x || !this.seriesChanged) {
      // We don't have previous data or series didn't change
      return false
    }

    let ticks0 = this.previous.scalers.x.groupScale.domain()
      , ticks1 = this.scalers.x.groupScale.domain()

    return ticks0.length === ticks1.length && // Same tick count on bottom
           this.exitingSeries.size() === 1 && // One serie being removed
           this.series.size() > this.previous.series.size() // We gained series
  }

  animate (serie, entering, selection, merged, exiting) {
    if (exiting.size()) {
      exiting.tween('grow-stroke', this.styleTweeners.growStroke(exiting))
             .tween('fade-out', this.styleTweeners.fadeOut(exiting, true))
    } else if (entering.size()) {
      let previousPoints = this.exitingSeries.selection().datum().points
        , scalers = {
          x: this.previous.scalers.x.center,
          y: (raw, d) => {
            let point = previousPoints.find(p => p.rangeId === d.rangeId)
            return this.previous.yScale(point.raw)
          }
        }

      // Add the new path elements at the old location
      this._insertPaths(entering, scalers)

      // Start the transition so the paths move to their new end locations
      this._updateDrawing(merged)

      merged.tween('piecewise-stroke', this.styleTweeners.piecewiseStroke(merged))
            .tween('fade-in', this.styleTweeners.fadeIn(merged))
    } else {
      // Basic update
      this._updateDrawing(merged) // update in case scale changed
    }
  }
}

export default SplitAreaAnimation
